import {Form, Select} from 'antd';
import {t} from 'i18next';
import {useEffect} from 'react';
import {RULES} from '@/constants';
import {useLang} from '@/hooks';
import {useCommonStore} from '@/stores';

interface NationalitiesProps {
  fieldName?: string;
  placeHolder?: string;
  label?: string;
  required?: boolean;
  disabled?: boolean
}

const Nationalities = ({
                         fieldName = 'nationalityId',
                         label = `${t('nationality')} :`,
                         placeHolder = t('selectNationality'),
                         required = false,
                         disabled = false
                       }: NationalitiesProps) => {
  const {getNationalities, nationalities} = useCommonStore();
  const {isLTR} = useLang();

  useEffect(() => {
    if (nationalities?.length === 0) {
      getNationalities();
    }
  }, []);

  return (
    <Form.Item
      rules={required ? [RULES.required] : []}
      name={fieldName}
      label={label}
    >
      <Select
        showSearch
        placeholder={placeHolder}
        filterOption
        optionFilterProp='label'
        getPopupContainer={trigger => trigger.parentNode}
        options={nationalities?.map(nationality => ({
          label: isLTR ? nationality?.en : nationality?.ar,
          value: nationality.objectID,
        }))}
        disabled={disabled}
      />
    </Form.Item>
  );
};
export default Nationalities;
